import { TFunctionType } from 'shared/entities/localization';

import { SelectorEntities } from '../../components/Selector';
import { GoogleBasicParamsServer } from '../GoogleBasic';
import {
  BlockBaseServer,
  EditableAttrsBlockServer,
  BlockType,
  BlockKind
} from '../common';

export type ReadFieldTypeServer =
  | ReadCellTableDataServer
  | ReadRangeTableDataServer;

export type ActionReadGoogleSheetsParamsServer = {
  target: string | null;
  read: ReadFieldTypeServer;
} & GoogleBasicParamsServer;

export type ReadCellTableDataServer = {
  kind: ReadTableKind.cell;
} & CellServer;

export type ReadRangeTableDataServer = {
  kind: ReadTableKind.range;
} & RangeCellsServer;

export type CellServer = {
  cell_id: string | null;
};

export type RangeCellsServer = {
  start_cell_id: string | null;
  end_cell_id: string | null;
};

export enum ReadTableKind {
  cell = 'cell',
  range = 'range'
}

export const readTableEntities = Object.values(ReadTableKind).reduce<
  SelectorEntities<ReadTableKind>
>(
  (acc, kind) => ({
    ...acc,
    [kind]: {
      id: kind,
      title: (t: TFunctionType): string =>
        t(`block.ActionReadGoogleSheets.readTableKind.${kind}`, {
          ns: 'entities'
        })
    }
  }),
  {} as SelectorEntities<ReadTableKind>
);

export const readTableOrder: ReadTableKind[] = [
  ReadTableKind.cell,
  ReadTableKind.range
];

export type ActionReadGoogleSheetsServer = BlockBaseServer<
  BlockType.action,
  BlockKind.readGoogleSheets
> &
  EditableAttrsBlockServer<ActionReadGoogleSheetsParamsServer>;
